<template>
  <div>
    <v-container v-if="!loading">
      <v-tabs grow v-model="currentTab" center-active>
        <v-tab v-for="items in CF4Compotents" :key="items.comp" class="font-weight-black">
          {{ items.name }}
        </v-tab>

        <v-tab-item v-for="items in CF4Compotents" :key="items.comp">
          <v-card flat tile>
            <patient-profile :currentTab="currentTab" :formData="formData" v-if="items.comp === 'PatientProfile'"/>
            <chief-complaint :currentTab="currentTab" :formData="formData" v-if="items.comp === 'ChiefComplaint'"/>
            <present-illness :currentTab="currentTab" :formData="formData"
                             v-if="items.comp === 'HistoryPresentIllness'"/>
            <past-med-history :currentTab="currentTab" :formData="formData"
                              v-if="items.comp === 'PertinentPastMedicalHistory'"/>
            <ob-gyne :currentTab="currentTab" :formData="formData" v-if="items.comp === 'OBGyneHistory'"/>
            <sign-symptoms :currentTab="currentTab" :formData="formData" v-if="items.comp === 'PertinentSignSymptoms'"/>
            <referred-hci :currentTab="currentTab" :formData="formData" v-if="items.comp === 'ReferredHCI'"/>
            <physical-exam :currentTab="currentTab" :formData="formData" v-if="items.comp === 'PhysicalExamination'"/>
            <course-ward :currentTab="currentTab" :formData="formData" v-if="items.comp === 'CourseWard'"/>
            <outcome-treatment :currentTab="currentTab" :formData="formData" v-if="items.comp === 'OutcomeTreatment'"/>
            <professional-certification :currentTab="currentTab" :formData="formData" v-if="items.comp === 'ProfessionalCertification'"/>
            <medicine :currentTab="currentTab" :formData="formData" v-if="items.comp === 'Medicine'"/>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-container>
    <v-container v-else style="text-align: center;">
      <v-progress-circular
          :size="150"
          color="primary"
          indeterminate
          style="text-align: center"
      >Loading Data
      </v-progress-circular>
    </v-container>
  </div>
</template>

<script>
import CF4Compotents from '@/components/core/components';
import ChiefComplaint from "./ChiefComplaint";
import PatientProfile from "./PatientProfile";
import HistoryPresentIllness from "./HistoryPresentIllness";
import PertinentPastMedicalHistory from "./PertinentPastMedicalHistory";
import OBGyneHistory from "./OBGyneHistory";
import PertinentSignSymptoms from "./PertinentSignSymptoms";
import ReferredHCI from "../CF4Components/Referred";
import PhysicalExamination from "./PhysicalExamination";
import CourseWard from "./CourseWard";
import Medicine from "./Medicine";
import OutcomeTreatment from "../CF4Components/OutcomeTreatment";
import ProfessionalCertification from "../CF4Components/ProfessionalCertification";

export default {
  components: {
    'patient-profile': PatientProfile,
    'chief-complaint': ChiefComplaint,
    'present-illness': HistoryPresentIllness,
    'sign-symptoms': PertinentSignSymptoms,
    'referred-hci': ReferredHCI,
    'ob-gyne': OBGyneHistory,
    'past-med-history': PertinentPastMedicalHistory,
    'physical-exam': PhysicalExamination,
    'course-ward': CourseWard,
    'medicine': Medicine,
    'outcome-treatment': OutcomeTreatment,
    'professional-certification': ProfessionalCertification,
  },

  data() {
    return {
      CF4Compotents: CF4Compotents,
      loading: true,
      formData: {
        patient: {
          claim_id: '',
          transmittal_id: '',
          patient_pin: '',
          patient_type: '',
          last_name: '',
          first_name: '',
          middle_name: '',
          suffix: '',
          gender: '',
          dob: '',
          admission_date: '',
          discharge_date: '',
          admission_time: '',
          discharge_time: '',
          admitting_diagnosis: '',
          discharge_diagnosis: '',
          first_case_rate_code: '',
          second_case_rate_code: '',
        },
        chief_complaint: {
          chief_complaint: '',
        },
        present_illness: {
          present_illness: '',
        },
        past_medical: {
          past_medical: '',
        },
        sign_symptoms: [],
        referred_hci: {
          is_referred: 'N',
          reason: '',
          originating_hci: ''
        },
        ob_gyne: {
          is_applicable: 'N',
          lmp: '',
          gravidity: '',
          parity: '',
          full_term: '',
          premature: '',
          abortion: '',
          living_children: '',
        },
        physical_examination: {
          vital_sign: {
            systolic: '',
            diastolic: '',
            hr: '',
            rr: '',
            temp: '',
          },
          general_survey: {
            gen_survey_id: '',
            gen_survey_remark: '',
          },
          heent: [],
          chest: [],
          heart: [],
          abdomen: [],
          guie: [],
          skin: [],
          neuro: [],
        },
        course_ward: [],
        medicine: [],
        outcome_treatment: {
          outcome: '',
          reason: ''
        },
        professional_certification: {
          attending_physician: '',
        }
      },
      currentTab: 0,
      submitForm: false,
      pid: this.$route.params.pid || null
    }
  },

  methods: {
    submitted() {
      this.submitForm = true;
    },

    edit() {
      const pid = this.pid;
      if (pid) {
        this.axios.post('edit', {pid: pid}, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
          }
        }).then((response) => {
          // handle success
          let data = response.data.data;
          this.formData = {
            patient: data.patient,

            chief_complaint: data.chief_complaint || { chief_complaint: '' },

            present_illness: data.present_illness || { present_illness: '' },

            past_medical: data.past_medical || { past_medical: '' },

            sign_symptoms: data.sign_symptom || [],

            referred_hci: data.referred_hci || {
              is_referred: 'N',
              reason: '',
              originating_hci: ''
            },

            ob_gyne: data.ob_gyne || {
              is_applicable: 'N',
              lmp: '',
              gravidity: '',
              parity: '',
              full_term: '',
              premature: '',
              abortion: '',
              living_children: '',
            },

            physical_examination: {
              vital_sign: data.vital_sign || {
                systolic: '',
                diastolic: '',
                hr: '',
                rr: '',
                temp: '',
              },

              general_survey: data.general_survey || {
                gen_survey_id: '',
                gen_survey_remark: '',
              },

              heent: data.heent || [],
              chest: data.chest || [],
              heart: data.heart || [],
              abdomen: data.abdomen || [],
              guie: data.guie || [],
              skin: data.skin || [],
              neuro: data.neuro || [],
            },

            course_ward: data.course_ward || [],

            medicine: data.medicine || [],

            outcome_treatment: data.outcome_treatment || {
              outcome: '',
              reason: ''
            },

            professional_certification: data.professional_certification || {
              attending_physician: '',
            },
          };
          this.loading = false;
        }).catch((error) => {
          // handle error
          console.error(error);
        });
      }
    },
  },

  mounted() {
    if (this.$bus) {
      this.$bus.on('nextTab', (data) => {
        this.currentTab = data;
      });
    }
    if (this.pid) {
      this.edit();
    } else {
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
